import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let person = useDataValue({
    context: 'credit_card_capture',
    path: 'person',
    viewPath: props.viewPath,
  })
  let responsible_person = useDataValue({
    context: 'credit_card_capture',
    path: 'responsible_person',
    viewPath: props.viewPath,
  })

  return [
    {
      id: 'patient',
      text: person
        ? `Patient: ${person.first_name} ${person.last_name}`
        : 'Patient',
    },
    {
      id: 'responsible_person',
      text: responsible_person
        ? `Responsible person: ${responsible_person.first_name} ${responsible_person.last_name}`
        : 'Responsible person',
    },
  ]
}
